// This file is where Old UI consumes the common Accounts Grid code.

import Backbone from 'backbone';
import _ from 'underscore';
import $ from 'jquery';

import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { getGridPreferences } from '@bingads-webui-campaign/summary-grid-helper';

import { createAccountsGridView } from './accounts-grid-factory';
import { gridsMap } from './constants';
import { isInPerformanceTab, isInSmartPerformanceTab } from './common-utils';
import FooterView from './grid-footer';

const Constants = globalContext.requireDefault('campaignui/feature/inline-chart/constants');
const AccountSummaryInlineChart = globalContext.requireDefault('campaignui/feature/inline-chart/view/inlinechartview');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/accounts-summary');
const qsContainerTemplate = globalContext.require('campaignui/feature/bingadsgrid/vnext/template/qs-container');
const { getSegPreference, getSegType } = globalContext.require('component/bingads-grid/service/segmentation-preferences');
const dateUtil = globalContext.require('component/humanize/date');
const segmentTimeChecker = globalContext.requireDefault('component/bingads-grid/shared/timeRangeChecker');
const state = globalContext.require('component/state/index');
const logger = globalContext.require('module/service/instrumentation/index');
const { fetchPaginationConfig } = globalContext.require('component/bingads-grid/service/fetch-pagination');

class QsView extends Backbone.View {
  render() {
    this.$el.html(qsContainerTemplate({ i18n }));

    return this;
  }
}

logger.logActivityMarker('AccountsSummaryGrid.Module.Loaded');

export function renderGrid({
  gridType,
  dashboardSettings,
  renderComplete,
  parentPerfMarker,
}) {
  const perfDurationMarker = logger.logActivityDurationMarker(`AccountsSummaryGrid.${gridType}.renderGrid`);

  const { gridName, el } = gridsMap[gridType];

  return getGridPreferences({
    gridName,
    dateUtil,
    state,
    getSegPreference,
    getSegType,
    segmentTimeChecker,
    fetchPaginationConfig,
  }).then((preferenceConfig) => {
    logger.logActivityMarker(`AccountsSummaryGrid.${gridType}.P$State.Resolved`);

    const newGrid = createAccountsGridView({
      el,
      gridType,
      preferenceConfig,
      parentPerfMarker,
      addDateChangeListener: (handler) => {
        window.App.views.Summary.bindDateFilterChangeHandler(handler);
      },
    });

    newGrid.render();

    const footerView = new FooterView({
      gridType,
      dashboardSettings,
    });
    footerView.render();
    newGrid.gridView.appendFootRows([{
      view: footerView,
      classes: ['noborder'],
    }]);

    const qsView = new QsView();
    qsView.render();
    newGrid.$el.append(qsView.el);

    if (isInPerformanceTab(gridType) || isInSmartPerformanceTab(gridType)) {
      const perfInlineChartNewDurationMarker = logger.logActivityDurationMarker('AccountsSummaryGrid.InlineChart.New');

      const chart = new AccountSummaryInlineChart({
        filter: newGrid.filter.getCurrentFilter(),
        entityType: Constants.AccountEdmEntity,
        isUsingVnextGrid: true,
      });

      perfInlineChartNewDurationMarker.markEnd();

      $('.inline-chart').append(chart.$el);

      // eslint-disable-next-line no-underscore-dangle
      newGrid.filterState.on('filterUpdated', chart._onGridPageLoadingNewGrid);

      if (window.App && window.App.views && window.App.views.Summary) {
        window.App.views.Summary.bindDateFilterChangeHandler(() => {
          // eslint-disable-next-line no-underscore-dangle
          chart._onGridPageLoadingNewGrid(newGrid.filter.getCurrentFilter());
        });
      }
    }

    if (_.isFunction(renderComplete)) {
      newGrid.gridView.once('didReload', () => {
        newGrid.gridView.once('didRedraw', () => {
          renderComplete();
        });
      });
    }

    perfDurationMarker.markEnd();
    return newGrid;
  });
}
